export default __webpack_public_path__ + "static/media/pic93.84924484.jpg";